{
  "panel": {
    "title": "Rapport",
    "previewTitle": "Aperçu du rapport",
    "loading": "Chargement du rapport...",
    "empty": "Aucune section générée pour le moment.",
    "emptyTitle": "Rien n'a encore été généré",
    "emptyHint": "Une fois la génération démarrée, les sections et les citations apparaîtront ici.",
    "loadFailed": "Impossible de charger le rapport.",
    "ariaPreviousVersion": "Version précédente",
    "ariaNextVersion": "Version suivante",
    "ariaEditSection": "Modifier la section",
    "ariaSaveChanges": "Enregistrer les modifications",
    "ariaCancelEditing": "Annuler la modification",
    "tooltipEdit": "Modifier",
    "section": {
      "pendingHint": "Le contenu apparaîtra ici une fois généré.",
      "contextUnavailable": "La récupération du contexte a échoué pour cette section. Essayez de la régénérer ou d’ajouter des fichiers sources.",
      "loading": "Chargement du contenu de la section…",
      "unavailable": "Cette section est signalée comme terminée mais aucun contenu n’est enregistré.",
      "needsAction": "Cette section n’a aucun contenu enregistré et doit être régénérée.",
      "acceptedNoContent": "Accepté — Aucun contenu",
      "awaitingExecSummary": "Le résumé exécutif est rédigé une fois toutes les sections terminées.",
      "loadFailed": "Le contenu de cette section n’a pas pu être chargé.",
      "reload": "Recharger le contenu"
    }
  },
  "generation": {
    "starting": "Démarrage de la génération du rapport...",
    "generating": "Génération des sections...",
    "sectionsCompleted": "{{completed}} sur {{total}} sections terminées",
    "currentSection": "Génération : {{title}}",
    "complete": "Rédaction du rapport terminée.",
    "failed": "Échec de la génération du rapport.",
    "abort": "Interrompre la génération",
    "aborting": "Interruption...",
    "aborted": "Génération interrompue.",
    "regenerate": "Régénérer le rapport",
    "regenerating": "Régénération...",
    "retryFailed": "Réessayer les sections en échec",
    "progressSections": "Génération des sections : {{completed}} sur {{total}} terminées",
    "progressSectionsRegenerating": "Génération des sections : {{completed}} sur {{total}} terminées ({{regenerating}} en régénération)",
    "progressCohortWait_one": "Passe globale en attente — {{count}} section en attente de la fin du lot",
    "progressCohortWait_other": "Passe globale en attente — {{count}} sections en attente de la fin du lot",
    "progressExtractingSymptoms": "En attente de la compilation des problèmes…",
    "progressAggregatingIssues": "Préparation du journal des problèmes…",
    "progressValidatingReport": "Validation du rapport…",
    "initiatingGeneration": "Lancement de la génération…",
    "generatingSections": "Génération des sections du rapport…",
    "progressExecSummary": "Génération du résumé exécutif…",
    "progressAwaitingValidation": "Sections en attente de validation…"
  },
  "section": {
    "untitled": "Section sans titre",
    "draft": "Brouillon",
    "validated": "Auto-vérifié",
    "generating": "Génération...",
    "failed": "Échec de la génération",
    "regenerate": "Régénérer la section",
    "regenerating": "Régénération...",
    "regenerateConfirm": "Régénérer cette section ?",
    "regenerateConfirmBody": "Le brouillon actuel sera remplacé. Les citations seront régénérées à partir des fichiers actuels.",
    "feedback": "Donner un retour",
    "feedbackTitle": "Retour sur la section",
    "feedbackPlaceholder": "Que faut-il changer dans cette section ?",
    "feedbackSubmit": "Envoyer le retour",
    "feedbackSubmitting": "Envoi du retour...",
    "feedbackSent": "Retour reçu. Régénération...",
    "feedbackEmpty": "Veuillez d'abord décrire votre retour.",
    "edit": "Modifier",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "saving": "Enregistrement...",
    "saveFailed": "Impossible d'enregistrer les modifications.",
    "expand": "Développer",
    "collapse": "Réduire",
    "viewSources": "Voir les sources",
    "noContent": "Aucun contenu pour le moment.",
    "errorBody": "Cette section n'a pas pu être générée. Cliquez sur Réessayer pour relancer."
  },
  "citation": {
    "viewSource": "Voir la source",
    "openFile": "Ouvrir le fichier",
    "page": "Page {{n}}",
    "pages": "Pages {{from}}–{{to}}",
    "evidence": "Preuve",
    "loading": "Chargement de la citation...",
    "loadFailed": "Impossible de charger la citation."
  },
  "execSummary": {
    "title": "Résumé exécutif",
    "generating": "Génération du résumé...",
    "complete": "Résumé prêt.",
    "failed": "Échec de la génération du résumé.",
    "regenerate": "Régénérer le résumé"
  },
  "holisticValidation": {
    "title": "Auto-vérification globale",
    "running": "Exécution des contrôles transversaux...",
    "passed": "Tous les contrôles transversaux ont réussi.",
    "issuesFound": "{{count}} problème détecté",
    "issuesFound_other": "{{count}} problèmes détectés",
    "viewIssues": "Voir les problèmes",
    "fixAll": "Tout corriger",
    "fixing": "Correction..."
  },
  "export": {
    "button": "Exporter",
    "buttonDocx": "Exporter en DOCX",
    "buttonPdf": "Exporter en PDF",
    "exporting": "Export en cours...",
    "ready": "Export prêt.",
    "failed": "Échec de l'export.",
    "downloadHere": "Télécharger",
    "exportTitle": "Exporter le rapport",
    "format": "Format",
    "includeAppendix": "Inclure l'annexe",
    "includeCitations": "Inclure la liste des citations"
  },
  "artifacts": {
    "title": "Artefacts",
    "showSpec": "Afficher la spécification",
    "hideSpec": "Masquer la spécification"
  },
  "execSummaryPinned": {
    "label": "Épinglé",
    "tooltip": "Vous avez modifié ce résumé : il est conservé tel quel et n'est pas actualisé automatiquement. Utilisez Commentaire pour le réécrire."
  }
}
